import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=c6d7c24e&scoped=true&"
import script from "./finished.vue?vue&type=script&lang=js&"
export * from "./finished.vue?vue&type=script&lang=js&"
import style0 from "./finished.vue?vue&type=style&index=0&id=c6d7c24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d7c24e",
  null
  
)

export default component.exports